import type { ModelDissociateButtonProps } from "./model-dissociate-button.type";
import type { ButtonProps } from "antd";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { getModelTranslationKey, type ModelItem } from "@/modules/model";
import { useSidePanel } from "@/modules/side-panel";

/** @deprecated - Create specific button for each model instead */
const ModelDissociateButton = <Item extends ModelItem>({
  modelKey,
  component,
  onClick,
  ...buttonProps
}: ModelDissociateButtonProps<Item>) => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();

  const onEditClick: ButtonProps["onClick"] = (e) => {
    const translationKey = getModelTranslationKey(modelKey);
    const title = t(`${translationKey}:dissociate:title`);

    openSidePanel({ title, component });
    onClick?.(e);
  };

  return (
    <Button onClick={onEditClick} {...buttonProps}>
      {t("global:dissociate")}
    </Button>
  );
};

export default ModelDissociateButton;
